// extracted by mini-css-extract-plugin
module.exports = {"spacing":"Spacing_spacing__jXD7V","spacing--horizontal":"Spacing_spacing--horizontal__INhO0","spacing--vertical":"Spacing_spacing--vertical__xgrTu"};